require("babel/polyfill");
require("./assets/js/material.js");
require("./assets/js/ripples.js");
require("./assets/css/font-awesome.min.css");
require("./node_modules/bootstrap/less/bootstrap.less");
require("./assets/less/wrapper.less");
require("./assets/less/app-base.less");
// emitted with a fixed name so it is served as /favicon.ico
require("!!file-loader?name=[name].[ext]!./assets/images/favicon.ico");

import React from "react";
import ReactDOM from "react-dom";
import jwt from "jsonwebtoken";
import  { fromJS } from 'immutable';
import { normalize, arrayOf, Schema } from "normalizr";
import {
  browserHistory,
  IndexRoute,
  Redirect,
  Route,
  Router,
} from "react-router";

import AirportWrapper from "./containers/airport/AirportWrapper.js";
import PricesWrapper from "./containers/prices/PricesWrapper.js";
import AirportsWrapper from "./containers/airports/AirportsWrapper.js";
import SuppliersWrapper from "./containers/suppliers/SuppliersWrapper.js";
import SupplierWrapper from "./containers/supplier/SupplierWrapper.js";
import PlattsWrapper from "./containers/platts/PlattsWrapper.js";
import Plattsv2Wrapper from "./containers/plattsv2/PlattsWrapper.js";
import PlattWrapper from "./containers/platt/PlattWrapper.js";
import Plattv2Wrapper from "./containers/plattv2/PlattWrapper.js";
import ContractsWrapper from "./containers/contracts/ContractsWrapper.js";
import FuelRequestsWrapper from './containers/fuelrequests/FuelRequestsWrapper.js';
import FbosWrapper from "./containers/fbos/FbosWrapper.js";
import FboWrapper from "./containers/fbo/FboWrapper.js";
import ContractWrapper from "./containers/contract/ContractWrapper.js";
import CalculatorWrapper from "./containers/calculator/CalculatorWrapper.js";
import UnauthorizedAccess from "./containers/errors/UnauthorizedAccess";
import PageNotFound from "./containers/errors/PageNotFound";
import ImportsWrapper from "./containers/import/ImportsWrapper.js";
import PriceAlerts from "./containers/pricealerts/PriceAlerts.js";
import WelcomeWrapper from "./containers/welcome/WelcomeWrapper.js";

import AuthApiUtils from "./utils/AuthApiUtils";

import { App, FrontEndApp } from "./components";
import { Activities } from "./constants";
import { LoginStore } from "./stores";
import { LoginAction } from "./actions";

console.log("mode: " + process.env.NODE_ENV);

if (process.env.NODE_ENV !== "production") {
  // var Perf = require('react-addons-perf');
  // window.Perf = Perf;
  // Perf.start();
}

//Define ajax params
$.ajaxSetup({
  error: function (jqXHR, textStatus, errorThrown) {
    if (jqXHR.status == 419) {
      LoginAction.timeout();
    } else {
      console.log("XHR Error", textStatus);
    }
  },
});

LoginStore.initialize();

// We check if there is a json token.
// if it's the case, we register the user before displaying the page.
acquireToken();

function acquireToken() {
  console.log("Acquiring token...");
  Promise.resolve($.ajax({ url: "/.auth/me", type: "GET" }))
    .then(function (data) {
      data = formalizeData(data).result[0].id_token;
      //data = "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImtpZCI6IlBjWDk4R1g0MjBUMVg2c0JEa3poUW1xZ3dNVSJ9.eyJhdWQiOiIzM2EyYWVhOC1kN2JiLTRiMzYtODE4NS1lM2JlZmQ4OTA0MTgiLCJpc3MiOiJodHRwczovL2xvZ2luLm1pY3Jvc29mdG9ubGluZS5jb20vZDU3OWU5YzMtYzZlMy00MzAwLWI1MDItZDYwNWYyYjcyMGEzL3YyLjAiLCJpYXQiOjE3Njc3MDcyMzQsIm5iZiI6MTc2NzcwNzIzNCwiZXhwIjoxNzY3NzExMTM0LCJhY2N0IjoxLCJhaW8iOiJBZFFBSy84YUFBQUFzd29jOEk1U1oxVGRIclc5T3BMcDNoN2FIWXNrd2NFK2RTanJXU3YxeXNBRWlEL2Vja0Myenp0elhZQkFRSURoK05YeHp0d2ZGTVlLNk03ZzZTMEU3YXNJc01YdlY4eEo5SElISk1KSUwvQjRuU2doWXpuVC80Rzh0NlNZSWhKK0pGOU5zWVRRM2N1MEhzSkdXMjByQW1URThmL1IyNVFNakl5Ukl6blNjbXJXVmZXTnk1bmh1aERvYnBBQm5RSGJWQTBvSHpZaU1PQTFoMUJJTHNhelJVa3d3ZW81RGdhR1NUK25JNG9rZURIeHJlSHN4SnZBSHhQOGtaTWdvUGxOYXBZekxCbEExdjFPTU52UHZEUlc0Zz09IiwiZW1haWwiOiJtYWdkYWxpbmEubmlrb2xvdmFAYWNjZWRpYS5jb20iLCJmYW1pbHlfbmFtZSI6Ik5pa29sb3ZhIiwiZ2l2ZW5fbmFtZSI6Ik1hZ2RhbGluYSIsImlkcCI6Imh0dHBzOi8vc3RzLndpbmRvd3MubmV0L2RkYjFkYzFhLTUwZTMtNDg4MC1hYTJlLWRkMjZiNjJkOWNiZi8iLCJuYW1lIjoiTWFnZGFsaW5hIE5pa29sb3ZhIiwibm9uY2UiOiIxMGVlOWUzZGIyN2I0Nzc1YjRmYmI1NzA5YTBmYjVmYV8yMDI2MDEwNjEzNTcwNyIsIm9pZCI6ImU0YjY2MGJlLWNkNzQtNDQzNS1hZjg4LWE3MGY0OTg2MjczNSIsInByZWZlcnJlZF91c2VybmFtZSI6Im1hZ2RhbGluYS5uaWtvbG92YUBhY2NlZGlhLmNvbSIsInJoIjoiMS5BUXNBdy1sNTFlUEdBRU8xQXRZRjhyY2dvNml1b2pPNzF6WkxnWVhqdnYySkJCZ3dBRVFMQUEuIiwicm9sZXMiOlsiRlVFTF9BRE1JTiJdLCJzaWQiOiIzOTA4ZjIyOS01NjhiLTQ3ODItYTg5YS1mMDgzN2RiOWFmMzEiLCJzdWIiOiI2Sl8tZncyWGRwX2hzMGVVbW1hei1QOVFyc1hfSUFxRWJPVkRLLTVKU1pVIiwidGlkIjoiZDU3OWU5YzMtYzZlMy00MzAwLWI1MDItZDYwNWYyYjcyMGEzIiwidXRpIjoiQzQwVUZyMnc4MHlrUEQ4QnhrOFlBUSIsInZlciI6IjIuMCJ9.d9IEYJuQZaijMo3K081emT4otJVqTPuA40BPNDBFk9i2fq7lB7rT-c6RFK8btfkvs_TJNw0Hfnd4O-WGqNyJBB_4O53vYBYwtCpcl2uU2SoNHmUJ_A4kQR200lNSZAsZ_4md1Ds-H9qvPom7GdWfQH7HsH1bXzXU_H5_aawmavCT7IoGHDw3cRLMI5elT0b3A5b_aWttRHAdmJJKMIyB887RZeLkJxqwv6xSLtrdwo-up_jybJbaf9JdWOtrue5CtgdasgB8fXuZsQP4rJq2y0cpSCdzjqJgmaah9Y27kiV-oyNRfEStgvkgkjpvsEP5ITCmJhhgWzSQpizJtGZOLw";
      const decoded = jwt.decode(data);
      if (LoginStore.isExpired(decoded)) {
        console.log("Token expired. Refreshing...");
        refreshToken();
      } else {
        console.log("Token acquired");
        LoginAction.register(data);
        //10 seconds before expiration: refresh
        const expirationDelay =
          decoded.exp - Math.floor(new Date().getTime() / 1000) - 10;
        console.log("The token expires in " + expirationDelay + " seconds");
        setTimeout(refreshToken, expirationDelay * 1000);

      }
    })
    .then(function(){
      renderDOM();
    })
    .catch(function (err) {
      if(err.status == 401) {
          window.location =
                "/.auth/login/aad?post_login_redirect_uri=" +
                encodeURIComponent(window.location.pathname + window.location.search);
      } else {
        console.log("Error "+ err.status +" : " + err.statusText);
      }

    });
}

function refreshToken() {
  Promise.resolve($.ajax({ url: "/.auth/refresh", type: "GET" })).then(
    function () {
      acquireToken();
    }
  );
}

var formalizeData = (data) => {
  return normalize(data, {});
};

function requireAuth(activity, nextState, replaceState) {
  if (!LoginStore.isLoggedIn()) {
    AuthApiUtils.login("/.auth/me");
  } else if (!LoginStore.isAuthorized(activity)) {
    replaceState({ nextPathname: nextState.location.pathname }, "/403");
  }
}

/**
 * Check if the user logged in is not an operator (pilot) before to continue
 * If he is, we redirect to 403
 */
function requireBackEndAuth(nextState, replaceState) {
  if (!LoginStore.isLoggedIn()) {
    AuthApiUtils.login("/.auth/me");
  } else if (LoginStore.isOperator()) {
    replaceState({ nextPathname: nextState.location.pathname }, "/403");
  }
}

function renderDOM() {
  console.log("RenderDOM");
  ReactDOM.render(
    <Router history={browserHistory}>
      <Route path="403" component={UnauthorizedAccess} />
      <Route path="404" component={PageNotFound} />
      <Route path="/" component={App}>
        <IndexRoute component={WelcomeWrapper} />

        <Route
        path="fuelrequests"
        component={FuelRequestsWrapper}
        onEnter={requireAuth.bind(this, Activities.READ_FUEL_REQUESTS)}/>

      <Route
        path="suppliers"
        component={SuppliersWrapper}
        onEnter={requireAuth.bind(this, Activities.READ_SUPPLIERS)}/>

      <Route
        path="suppliers/:id"
        component={SupplierWrapper}
        onEnter={requireAuth.bind(this, Activities.READ_SUPPLIERS)}/>

      <Route
        name="airports"
        path="airports"
        component={AirportsWrapper}
        onEnter={requireAuth.bind(this, Activities.READ_AIRPORTS)}/>

      <Route
        path="airports/:icao"
        component={AirportWrapper}
        onEnter={requireAuth.bind(this, Activities.READ_AIRPORTS)}/>

      <Route
        path="platts"
        component={PlattsWrapper}
        onEnter={requireAuth.bind(this, Activities.READ_PLATTS)}/>

      <Route
        path="plattsv2"
        component={Plattsv2Wrapper}
        onEnter={requireAuth.bind(this, Activities.READ_FUEL_PRICES)}/>

      <Route
        path="platts/:id"
        component={PlattWrapper}
        onEnter={requireAuth.bind(this, Activities.READ_PLATTS)}/>

      <Route
        path="plattsv2/:icao/:supplier"
        component={Plattv2Wrapper}
        onEnter={requireAuth.bind(this, Activities.READ_PLATTS)}/>

      <Route
        path="contracts"
        component={ContractsWrapper}
        onEnter={requireAuth.bind(this, Activities.READ_CONTRACTS)}/>

      <Route
        path="contracts/:id"
        component={ContractWrapper}
        onEnter={requireAuth.bind(this, Activities.READ_CONTRACTS)}/>

      <Route
        path="fbos"
        component={FbosWrapper}
        onEnter={requireAuth.bind(this, Activities.READ_FBOS)}/>

      <Route
        path="fbos/:id"
        component={FboWrapper}
        onEnter={requireAuth.bind(this, Activities.READ_FBOS)}/>

      <Route
        path="/indexes"
        component={CalculatorWrapper}
        onEnter={requireAuth.bind(this, Activities.USE_FUEL_SIMULATOR)}/>

      <Route
        path="/prices"
        component={PricesWrapper}
        onEnter={requireAuth.bind(this, Activities.READ_FUEL_PRICES)}/>

      <Route
        path="/import"
        component={ImportsWrapper}
        onEnter={requireAuth.bind(this, Activities.IMPORT_CONTRACTS)}/>

      <Route
        path="/price-alerts"
        component={PriceAlerts}
        onEnter={requireAuth.bind(this, Activities.READ_PRICES)}/>

      </Route>
      <Route
        path="/simulator"
        component={FrontEndApp}
        onEnter={requireAuth.bind(this, Activities.USE_FUEL_SIMULATOR)}
      >
        <IndexRoute component={CalculatorWrapper} />
      </Route>
      <Redirect from="*" to="/404" />
    </Router>,
    document.getElementById("app-wrapper")
  );
}
